import { AnswerCommand } from 'core/commands/elements/answers/answer.abstract.command';
import { tactileoAnswersDTOTypes } from 'utils/activityItem.util';

export class H5PQuestionAnswerCommand extends AnswerCommand {
  constructor(h5pQuestion) {
    super(tactileoAnswersDTOTypes.H5P_QUESTION, h5pQuestion);
    this.answer = h5pQuestion.answer;
  }
}
